module.exports = __webpack_public_path__ + "static/media/ic_arrow_left_focus.3e321d20.svg";